import { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { admin, adminRoute } from "../../globals/route-names";

function AdminImpersonationBanner() {
    const { user, returnToAdmin } = useAuth();
    const [busy, setBusy] = useState(false);
    const [message, setMessage] = useState("");

    if (!user?.impersonating) return null;

    const handleReturn = async () => {
        setBusy(true);
        setMessage("");
        try {
            await returnToAdmin();
            window.location.href = adminRoute(admin.DASHBOARD);
        } catch (error) {
            setMessage(error.message);
            setBusy(false);
        }
    };

    return (
        <div className="alert alert-warning d-flex flex-wrap align-items-center justify-content-between m-b0">
            <div>
                Admin login-as mode: viewing <strong>{user.name}</strong> ({user.email}) as {user.role}.
                {message && <span className="ms-2 text-danger">{message}</span>}
            </div>
            <button className="btn btn-sm btn-dark" type="button" onClick={handleReturn} disabled={busy}>
                {busy ? "Returning..." : "Return to Admin"}
            </button>
        </div>
    );
}

export default AdminImpersonationBanner;
